
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { BotMappingTab } from './BotMappingTab';
import { HistoricalAnalysisTab } from './HistoricalAnalysisTab';
import { BotMergeSignalMonitor } from './BotMergeSignalMonitor';
import { BotMergeAnalytics } from './BotMergeAnalytics';
import { BotMergeErrorDebug } from './BotMergeErrorDebug';

export const BotMergeManager: React.FC = () => {
  return (
    <Tabs defaultValue="mapping" className="w-full">
      <TabsList className="grid w-full grid-cols-5">
        <TabsTrigger value="mapping">Bot Mapping</TabsTrigger>
        <TabsTrigger value="analysis">Historical Analysis</TabsTrigger>
        <TabsTrigger value="monitor">Signal Monitor</TabsTrigger>
        <TabsTrigger value="analytics">Analytics</TabsTrigger>
        <TabsTrigger value="debug">Error Debug</TabsTrigger>
      </TabsList>
      
      <TabsContent value="mapping" className="space-y-6">
        <BotMappingTab />
      </TabsContent>
      
      <TabsContent value="analysis" className="space-y-6">
        <HistoricalAnalysisTab />
      </TabsContent>
      
      <TabsContent value="monitor" className="space-y-6">
        <BotMergeSignalMonitor />
      </TabsContent>
      
      <TabsContent value="analytics" className="space-y-6">
        <BotMergeAnalytics />
      </TabsContent>

      <TabsContent value="debug" className="space-y-6">
        <BotMergeErrorDebug />
      </TabsContent>
    </Tabs>
  );
};
